<template>
  <card :title="$t('your_info')">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="update"
      @keydown="form.onKeydown($event)"
    >
      <v-container grid-list-xl>
        <v-layout
          id="ref"
          class="wrap justify-space-around form-body"
        >
          <v-col cols="6">
            <v-text-field
              v-model="form.name"
              :rules="[rules.required]"
              label="Nombre"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.emailFormat]"
              label="Correo Electronico"
              :readonly="true"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.identificator"
              :rules="[rules.required, rules.identificatorFormat, rules.identificatorLength]"
              label="Identificación"
              placeholder="Cédula"
              :maxlength="11"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.phone"
              :rules="[rules.phoneLength]"
               v-mask="'####-###-####'"
              :maxlength="13"
              label="Teléfono"
              type="tel"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_province_id"
              :items="itemsProvince"
              item-value="id"
              item-text="name"
              label="Estado"
              @change="getDistrito()"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_district_id"
              :items="itemsDistrict"
              item-value="id"
              item-text="name"
              label="Municipio"
              @change="getCorregimiento()"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_corregimiento_id"
              :items="itemsCorregimiento"
              item-value="id"
              item-text="name"
              label="Parroquia"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.address"
              :maxlength="300"
              label="Dirección"
              placeholder="Dirección"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              v-if="can('actualiza_perfil_usuario')"
              :loading="form.busy"
              :disabled="!valid || form.busy"
              class="mr-4"
              block
              color="success"
              @click="validate"
            >
              {{ $t('update') }}
            </v-btn>
          </v-col>
        </v-layout>
      </v-container>
    </v-form>
  </card>
</template>

<script>
import Form from 'vform';
import { mask } from 'vue-the-mask';

export default {
  directives: {
    mask,
  },
  metaInfo() {
    return { title: this.$t('settings') };
  },
  data: () => ({
    form: new Form({
      name: '',
      email: '',
      identificator: '',
      phone: '',
      cat_corregimiento_id: '',
      cat_district_id: '',
      cat_province_id: '',
      address: '',
      busy: false,
    }),
    valid: false,
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      identificatorLength: (v) => (!v || v.length > 6) || 'El campo debe tener al menos 7 caracteres.',
      identificatorFormat: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
      phoneLength: (v) => (!v || v.length === 13) || 'El campo debe tener de 11 caracteres numéricos.',
    },
    apiURL: '/api/settings/profile',
  }),
  watch: {
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
    const URL = `${this.apiURL}`;
    this.URL = URL;
      window.axios.get('/api/user')
      .then((result) => {
        Object.assign(this.form, result.data.user);
        this.URL = '/api/settings/profile';
        this.method = 'PUT';
        this.title = 'Actualizar información';
        this.message = 'Se ha actualizado la información exitosamente.';
      });
  },
  methods: {
    update() {
      window.axios({
        method: this.method,
        url: this.URL,
        data: this.form,
      }).then((result) => {
        this.$router.push({ name: 'settings.profile', params: { action: 'created', message: result.data.message } });
        this.form.busy = false;
      }).catch(() => {
        this.form.busy = false;
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.update();
      }
    },
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
          const url = `/api/districts/${this.form.cat_province_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsDistrict = response.data;
        });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
          const url = `/api/corregimientos/${this.form.cat_district_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsCorregimiento = response.data;
        });
      }
    },
  },
};
</script>
